import { useEffect, useRef } from 'react';
import type { JawsSegmentationResponse } from '@/schema/jawsSegmentation';
import { CorrectionScene } from '@correction/three/CorrectionScene.ts';
import useCorrectionStore from './hooks/useCorrectionStore';

interface Props {
  jawsSegmentation: JawsSegmentationResponse;
}

export function CorrectionCanvas({ jawsSegmentation }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const sceneRef = useRef<CorrectionScene>(undefined);
  const { reset } = useCorrectionStore();

  useEffect(() => {
    if (!containerRef.current) return;

    const scene = new CorrectionScene(containerRef.current);
    sceneRef.current = scene;
    scene.init(jawsSegmentation);

    return () => {
      reset();
      scene.dispose();
      sceneRef.current = undefined;
    };
  }, []);

  return <div ref={containerRef} className="h-full w-full rounded-3xl" />;
}
